import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type MyTenantsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MyTenantsQuery = { __typename?: 'Query', myTenants: Array<{ __typename?: 'MyTenant', id: string, name: string }> };


export const MyTenantsDocument = new TypedDocumentString(`
    query MyTenants {
  myTenants {
    id
    name
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    MyTenants: build.query<MyTenantsQuery, MyTenantsQueryVariables | void>({
      query: (variables) => ({ document: MyTenantsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useMyTenantsQuery, useLazyMyTenantsQuery } = injectedRtkApi;
